import { BareActionContext } from 'vuex-typex'
import { CommentState } from '../state'
import { RootState } from '../..'
import { IStatement, StatementMeta } from '../../../model/statement'
import statementStore from '../../statement/statement-store'
import commentUtils from '@/store/comment/actions/comment-utils';
import { IComment } from '@/model/comment';
import commentStore from '@/store/comment/comment-store';

export default async function fetchStatements(context: BareActionContext<CommentState, RootState>, comment: IComment) {
  commentUtils.commentService.getStatements(comment).then((statements: IStatement[]) => {
    for (let i=0; i<statements.length; i++) {
      if (statementStore.state.statementMap.has(statements[i].id as number)) {
        statements[i] = statementStore.state.statementMap.get(statements[i].id as number) as IStatement
      } else {
        statementStore.state.statementMap.set(statements[i].id as number, statements[i])
        statements[i].meta = new StatementMeta()
      }
    }
    commentStore.commitSetStatements({ comment: comment, statements: statements })
    for(let i=0; i<statements.length; i++) {
      if (!statements[i].isMetaSet) {
        statementStore.dispatchSetMeta(statements[i])
      }
    }
  })

  return
}
